/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnumerationDataSetSetupDto } from './EnumerationDataSetSetupDto';
import {
    instanceOfEnumerationDataSetSetupDto,
    EnumerationDataSetSetupDtoFromJSON,
    EnumerationDataSetSetupDtoFromJSONTyped,
    EnumerationDataSetSetupDtoToJSON,
} from './EnumerationDataSetSetupDto';
import type { NumericDataSetSetupDto } from './NumericDataSetSetupDto';
import {
    instanceOfNumericDataSetSetupDto,
    NumericDataSetSetupDtoFromJSON,
    NumericDataSetSetupDtoFromJSONTyped,
    NumericDataSetSetupDtoToJSON,
} from './NumericDataSetSetupDto';
import type { TextDataSetSetupDto } from './TextDataSetSetupDto';
import {
    instanceOfTextDataSetSetupDto,
    TextDataSetSetupDtoFromJSON,
    TextDataSetSetupDtoFromJSONTyped,
    TextDataSetSetupDtoToJSON,
} from './TextDataSetSetupDto';

/**
 * @type DataSetSetupValueDto
 * 
 * @export
 */
export type DataSetSetupValueDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } & EnumerationDataSetSetupDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } & NumericDataSetSetupDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.TextDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } & TextDataSetSetupDto;


export function DataSetSetupValueDtoFromJSON(json: any): DataSetSetupValueDto {
    return DataSetSetupValueDtoFromJSONTyped(json, false);
}

export function DataSetSetupValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSetSetupValueDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, EnumerationDataSetSetupDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, NumericDataSetSetupDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.TextDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TextDataSetSetupDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.TextDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of DataSetSetupValueDto exists with '$type=${json['$type']}'`);
    }
}

export function DataSetSetupValueDtoToJSON(value?: DataSetSetupValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return EnumerationDataSetSetupDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return NumericDataSetSetupDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.TextDataSetSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TextDataSetSetupDtoToJSON(value);
        default:
            throw new Error(`No variant of DataSetSetupValueDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the DataSetSetupValueDto interface.
 */
export function instanceOfDataSetSetupValueDto(value: any): value is DataSetSetupValueDto {
    if (instanceOfEnumerationDataSetSetupDto(value)) return true;
    if (instanceOfNumericDataSetSetupDto(value)) return true;
    if (instanceOfTextDataSetSetupDto(value)) return true;
    return false;
}

